import { Product, ProductPriceUnit, ProductType } from '@app/api';
import { OfferItem } from './OfferItem';
import { Trans } from 'react-i18next';
import { Emph } from './Emph';

interface Props {
  product: Product;
}

const components = { emph: <Emph /> };

export const ProductOfferItem = ({ product }: Props) => {
  if (product.type === ProductType.CREDITS) {
    const price =
      product.priceUnit === ProductPriceUnit.EUR ? product.price : 0;
    const credits = product.credits ? product.credits : 0;

    if (price && credits > price) {
      return (
        <OfferItem
          text={
            <Trans
              i18nKey="billing.products.creditsWithExtra"
              components={components}
              values={{
                amount: price,
                extraCredits: credits - price,
              }}
            />
          }
        />
      );
    }
    return (
      <OfferItem
        text={
          <Trans
            i18nKey="billing.products.credits"
            components={components}
            values={{
              amount: price || credits,
            }}
          />
        }
      />
    );
  }

  return <OfferItem text={product.title} />;
};
